<template>
    <app-cmp-tabs default="content" v-if="this.element">
        <div class="flex" slot-scope="{ toggle, active }">
            <app-cmp-tabs-trigger name="content" :handle-click="toggle" :active="active">
                <app-icon icon="file-alt" class="mr-2" /></i>General
            </app-cmp-tabs-trigger>
            <app-cmp-tabs-trigger name="box" :handle-click="toggle" :active="active">
                <app-icon icon="th-large" class="mr-2" /></i>Box Model
            </app-cmp-tabs-trigger>
            <app-cmp-tabs-trigger name="design" :handle-click="toggle" :active="active">
                <app-icon icon="pencil-alt" class="mr-2" />Design
            </app-cmp-tabs-trigger>
        </div>
        <div slot="items" slot-scope="{ active }">
            <app-cmp-tabs-content name="content" :active="active">
                <div class="bg-white p-4 font-bold text-sm" style="border-top: 1px solid #d3d3d3; border-bottom: 1px solid #d3d3d3;">
                    Properties
                </div>

                <div class="flex flex-wrap items-center px-6 py-4" style="border-bottom: 1px solid rgb(211, 211, 211);">
                    <div class="w-1/2">
                        <label class="text-xs text-grey-darker">
                            Row relative
                        </label>
                    </div>
                    <div class="w-1/2 text-right">
                        <app-toggle-field
                            :required="false"
                            class="reset"
                            :classes="{ input: { 'input--composer': true } }"
                            v-model="element.object.settings.relative"
                        />
                    </div>
                </div>

                <div class="flex flex-wrap items-center px-6 py-4" style="border-bottom: 1px solid rgb(211, 211, 211);">
                    <div class="w-1/2">
                        <label class="text-xs text-grey-darker">
                            Row styling reset
                        </label>
                    </div>
                    <div class="w-1/2 text-right">
                        <app-toggle-field
                            :required="false"
                            class="reset"
                            :classes="{ input: { 'input--composer': true } }"
                            v-model="element.object.settings.reset"
                        />
                    </div>
                </div>

                <div class="bg-white p-4 font-bold text-sm" style="border-top: 1px solid #d3d3d3; border-bottom: 1px solid #d3d3d3;">
                    Reverse columns
                </div>
                <div class="flex flex-wrap items-center px-6 py-4" style="border-bottom: 1px solid rgb(211, 211, 211);">
                    <div class="w-1/2">
                        <label class="text-xs text-grey-darker">
                            Enable
                        </label>
                    </div>
                    <div class="w-1/2 text-right">
                        <app-toggle-field
                            :required="false"
                            class="reset"
                            :classes="{ input: { 'input--composer': true } }"
                            v-model="element.object.settings.reverse.enable"
                        />
                    </div>
                </div>

                <div :class="(element.object.settings.reverse.enable != 'undefined' && element.object.settings.reverse.enable == true ? 'block' : 'hidden')">
                    <div class="flex flex-wrap items-center px-6 py-4" style="border-bottom: 1px solid rgb(211, 211, 211);">
                        <div class="w-1/2">
                            <label class="text-xs text-grey-darker pl-4">
                                Default column
                            </label>
                        </div>
                        <div class="w-1/2 text-right">
                            <app-toggle-field
                                :required="false"
                                class="reset"
                                :classes="{ input: { 'input--composer': true } }"
                                v-model="element.object.settings.reverse.default"
                            />
                        </div>
                    </div>

                    <div class="flex flex-wrap items-center px-6 py-4" style="border-bottom: 1px solid rgb(211, 211, 211);">
                        <div class="w-1/2">
                            <label class="text-xs text-grey-darker pl-4">
                                Small column
                            </label>
                        </div>
                        <div class="w-1/2 text-right">
                            <app-toggle-field
                                :required="false"
                                class="reset"
                                :classes="{ input: { 'input--composer': true } }"
                                v-model="element.object.settings.reverse.small"
                            />
                        </div>
                    </div>

                    <div class="flex flex-wrap items-center px-6 py-4" style="border-bottom: 1px solid rgb(211, 211, 211);">
                        <div class="w-1/2">
                            <label class="text-xs text-grey-darker pl-4">
                                Medium column
                            </label>
                        </div>
                        <div class="w-1/2 text-right">
                            <app-toggle-field
                                :required="false"
                                class="reset"
                                :classes="{ input: { 'input--composer': true } }"
                                v-model="element.object.settings.reverse.medium"
                            />
                        </div>
                    </div>

                    <div class="flex flex-wrap items-center px-6 py-4" style="border-bottom: 1px solid rgb(211, 211, 211);">
                        <div class="w-1/2">
                            <label class="text-xs text-grey-darker pl-4">
                                Large column
                            </label>
                        </div>
                        <div class="w-1/2 text-right">
                            <app-toggle-field
                                :required="false"
                                class="reset"
                                :classes="{ input: { 'input--composer': true } }"
                                v-model="element.object.settings.reverse.large"
                            />
                        </div>
                    </div>

                    <div class="flex flex-wrap items-center px-6 py-4" style="border-bottom: 1px solid rgb(211, 211, 211);">
                        <div class="w-1/2">
                            <label class="text-xs text-grey-darker pl-4">
                                Extra large column
                            </label>
                        </div>
                        <div class="w-1/2 text-right">
                            <app-toggle-field
                                :required="false"
                                class="reset"
                                :classes="{ input: { 'input--composer': true } }"
                                v-model="element.object.settings.reverse.xlarge"
                            />
                        </div>
                    </div>
                </div>
            </app-cmp-tabs-content>
            <app-cmp-tabs-content name="box" :active="active">
                <app-cmp-box-model
                    :element="element.object"
                />

                <app-cmp-border
                    :element="element.object"
                />
            </app-cmp-tabs-content>
            <app-cmp-tabs-content name="design" :active="active">
                <app-cmp-design
                    :element="element.object"
                />
            </app-cmp-tabs-content>
        </div>
    </app-cmp-tabs>
</template>

<script>
    import CmpTabs from '@/components/composer/Tabs/Tabs';
    import CmpTabsTrigger from '@/components/composer/Tabs/TabsTrigger';
    import CmpTabsContent from '@/components/composer/Tabs/TabsContent';

    import ToggleField from '@/components/fields/inputs/Toggle';

    import CmpBoxModel from '@/components/composer/Forms/Partials/BoxModel';
    import CmpBorder from '@/components/composer/Forms/Partials/Border';
    import CmpDesign from '@/components/composer/Forms/Partials/Design';

    export default {
        components: {
            'app-cmp-tabs': CmpTabs,
            'app-cmp-tabs-trigger': CmpTabsTrigger,
            'app-cmp-tabs-content': CmpTabsContent,
            'app-cmp-box-model': CmpBoxModel,
            'app-cmp-border': CmpBorder,
            'app-cmp-design': CmpDesign,
            'app-toggle-field': ToggleField,
        },
        props: {
            element: {
                type: Object,
                required: true
            }
        },
        data: () => ({
            fields: {
                relative: {
                    name: 'Row relative',
                    attribute: 'relative'
                },
                reset: {
                    name: 'Container reset',
                    attribute: 'reset'
                },
                reverse: {
                    enable: {
                        name: 'Enable',
                        attribute: 'enableReverse'
                    },
                    default: {
                        name: 'Reverse',
                        attribute: 'reverse'
                    },
                    small: {
                        name: 'Reverse small',
                        attribute: 'smallReverse'
                    },
                    medium: {
                        name: 'Reverse medium',
                        attribute: 'mediumReverse'
                    },
                    large: {
                        name: 'Reverse large',
                        attribute: 'largeReverse'
                    },
                    xlarge: {
                        name: 'Reverse extra large',
                        attribute: 'xlargeReverse'
                    }
                }
            }
        }),
    }
</script>



// WEBPACK FOOTER //
// src/components/composer/Forms/Row.vue